import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore } from '@mcn-platform/models';
import { Link } from 'react-router-dom';
const limitToPageWidth = true;
const Member = ({ memberID }) => {
    const store = useStore();
    const { currentCustomer } = store;
    const member = memberID ? store.getOrLoad('member', memberID) : undefined;
    if (!currentCustomer) {
        return (_jsx(Box, { sx: {
                ...(limitToPageWidth && {
                    width: '100%',
                    maxWidth: 1200,
                    marginX: 'auto',
                }),
            }, children: _jsx(Box, { sx: { m: 4 }, children: "Please log-in" }) }));
    }
    return (_jsxs(Box, { sx: {
            ...(limitToPageWidth && {
                width: '100%',
                maxWidth: 1200,
                marginX: 'auto',
            }),
        }, children: [store.currentMembers?.map((mem) => (_jsxs("div", { children: [mem.id, _jsx(Link, { to: `member/${mem.id}`, children: "View Details" })] }))), member && (_jsxs(Box, { children: ["MEMBER", memberID, member.membership.name, member.membership.summary(), _jsx("br", {}), member.status, member.status === 'PENDING' && (_jsx("span", { children: " Complete purchase" }))] })), _jsx("br", {})] }));
};
Member.defaultProps = {};
Member.meta = {
    group: 'hidden',
    name: 'Membership Details',
    description: 'Show detailed information on a customer membership.',
    props: [
        {
            key: 'memberID',
            name: 'Member',
            type: 'member', // note this is a special type recognized by the system
            description: 'The member record to display.',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'Member',
        props: {
            memberID: '@memberID',
        },
    },
};
export default observer(Member);
//# sourceMappingURL=Member.js.map